import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, MessageCircleHeart } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const isActive = (p) => loc.pathname === p;
  const linkCls = (p) =>
    `text-sm font-semibold tracking-wide transition-colors ${
      isActive(p) ? "text-[#2E9D96]" : "text-slate-600 hover:text-[#2E9D96]"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-[#F4F7F6]/85 backdrop-blur-xl border-b border-slate-200/70">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to={user ? "/chat" : "/"} data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#2E9D96] flex items-center justify-center text-white">
            <MessageCircleHeart size={16} />
          </div>
          <span className="font-display text-xl text-slate-800">Zaf</span>
        </Link>

        {user ? (
          <nav className="flex items-center gap-6">
            <Link to="/chat" className={linkCls("/chat")} data-testid="nav-chat">Chat</Link>
            <Link to="/profile" className={linkCls("/profile")} data-testid="nav-profile">Profile</Link>
            <Link to="/billing" className={linkCls("/billing")} data-testid="nav-billing">Billing</Link>
            {user.is_admin && (
              <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>
            )}
            <button
              data-testid="nav-logout"
              onClick={() => { logout(); nav("/"); }}
              className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#C15B5B] transition-colors"
            >
              <LogOut size={16} /> Sign out
            </button>
          </nav>
        ) : (
          <nav className="flex items-center gap-4">
            <Link to="/login" className="text-sm font-semibold text-slate-700 hover:text-[#2E9D96]" data-testid="nav-login">Log in</Link>
            <Link to="/signup" className="text-sm font-semibold text-white bg-[#2E9D96] hover:bg-[#1F7B75] rounded-full px-5 py-2 transition-colors" data-testid="nav-join">Join</Link>
          </nav>
        )}
      </div>
    </header>
  );
}
